export const SET_ALERT = "SET_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";

export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT = "LOGOUT";

export const ALL_CLIENTS = "ALL_CLIENTS";
export const CLIENT = "CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const REMOVE_CLIENT = "REMOVE_CLIENT";
export const CREATE_CLIENT = "CREATE_CLIENT";
export const ERR_CLIENTS = "ERR_CLIENTS";

export const ALL_USERS = "ALL_USERS";
export const USER = "USER";
export const UPDATE_USER = "UPDATE_USER";
export const REMOVE_USER = "REMOVE_USER";
export const CREATE_USER = "CREATE_USER";
export const ERR_USERS = "ERR_USERS";

export const ALL_CAMPAIGN = "ALL_CAMPAIGN";
export const ALL_ASSIGNED_CAMPAIGNS = "ALL_ASSIGNED_CAMPAIGNS";
export const ASSIGN_CAMPAIGN = "ASSIGN_CAMPAIGN";
export const ERR_CAMPAIGN = "ERR_CAMPAIGN";

export const CAMPAIGN_PROMO = "CAMPAIGN_PROMO";
export const ALL_PROMO_BATCH = "ALL_PROMO_BATCH";
export const CREATE_PROMO_BATCH_LOADING = "CREATE_PROMO_BATCH_LOADING";
export const CREATE_PROMO_BATCH = "CREATE_PROMO_BATCH";
export const UPDATE_PROMO_BATCH = "UPDATE_PROMO_BATCH";
export const REMOVE_PROMO_BATCH = "REMOVE_PROMO_BATCH";
export const ALL_PROMO = "ALL_PROMO";
export const REMOVE_PROMO = "REMOVE_PROMO";
export const UPDATE_PROMO = "UPDATE_PROMO";
export const ERR_PROMO = "ERR_PROMO";
export const UPDATE_ERR_PROMO = "UPDATE_ERR_PROMO";

export const CREATE_BIN_BATCH_LOADING = "CREATE_BIN_BATCH_LOADING";
export const CREATE_BIN_BATCH = "CREATE_BIN_BATCH";
export const ERR_BINS = "ERR_BINS";
export const UPDATE_ERR_BIN = "UPDATE_ERR_BIN";
export const ALL_BINS = "ALL_BINS";
export const UPDATE_BIN = "UPDATE_BIN";
export const ALL_BIN_BATCH = "ALL_BIN_BATCH";

// fetch all banners of a campaign , delete one banner of a campaign
// edit one banner of a campaign , add new banner in a campaign
export const CAMPAIGN_BANNERS = "CAMPAIGN_BANNERS";
export const BANNERS_LIST = "BANNERS_LIST";
export const ERR_CAMPAIGN_BANNERS = "ERR_CAMPAIGN_BANNERS";
// export const ERR_BANNER = "ERR_UPDATE_BANNER";
export const REMOVE_BANNER = "REMOVE_BANNER";
export const CREATE_CAMPAIGN_BANNER = "CREATE_CAMPAIGN_BANNER";
export const UPDATE_CAMPAIGN_BANNER = "UPDATE_CAMPAIGN_BANNER";
export const DELETE_CAMPAIGN_BANNER = "DELETE_CAMPAIGN_BANNER";

export const GET_QUICKLINKS_OF_BANNER = "GET_QUICKLINKS_OF_BANNER";
export const CREATE_QUICKLINK_BANNER = "CREATE_QUICKLINK_OF_BANNER";
export const ERR_QUICKLINKS = "ERR_QUICKLINKS";
export const CREATE_BRANDPARTNER = "CREATE_BRANDPARTNER";
export const ERR_BRANDPARTNER = "ERR_BRANDPARTNER";
export const GET_BRANDPARTNER = "GET_BRANDPARTNER";

export const CREATE_BANNER = "CREATE_BANNER";
export const ERR_BANNER = "ERR_BANNER";
export const UPLOADIMAGE = "UPLOADIMAGE";
export const UPDATEIMAGE = "UPDATEIMAGE";
export const CREATEHEADER = "CREATEHEADER";
export const CREATEBODY = "CREATEBODY";
export const CREATEBODYPLUTOS = "CREATEBODYPLUTOS";
export const CREATEFOOTER = "CREATEFOOTER";
export const SAVECAMPAIGNID = "SAVECAMPAIGNID";
export const GETDATA = "GETDATA";
export const UPDATEHEADER = "UPDATEHEADER";
export const UPDATEBODY = "UPDATEBODY";
export const UPDATEFOOTER = "UPDATEFOOTER";
export const GETDATAHEADER = "GETDATAHEADER";
export const DELETEALL = "DELETEALL";
export const GETPERTICULAR = "GETPERTICULAR";
export const GETFOOTER = "GETFOOTER";
export const GETIMAGES = "GETIMAGES";

//update assign campaigns
export const UPDATE_ASSIGN_CAMPAIGN = "UPDATE_ASSIGN_CAMPAIGN";

//update static data
export const ALL_EMPLOYEES = "ALL_EMPLOYEES";
export const EMPLOYEE = "EMPLOYEE";
export const UPDATE_EMPLOYEE = "UPDATE_EMPLOYEE";
export const REMOVE_EMPLOYEE = "REMOVE_EMPLOYEE";
export const CREATE_EMPLOYEE = "CREATE_EMPLOYEE";
export const ERR_EMPLOYEES = "ERR_EMPLOYEES";


//Blog data
export const blogs_actions = {
   CREATE_BLOGS: "CREATE_BLOGS",
   GET_BLOGS: "GET_BLOGS",
   UPDATE_BLOGS: "UPDATE_BLOGS",
   DELETE_BLOGS: "DELETE_BLOGS",
   ERR_BLOGS: "ERR_BLOGS",
   VIEW_BLOGS: "VIEW_BLOGS",

}

export const category_actions = {
   CREATE_CATEGORY: "CREATE_CATEGORY",
   GET_CATEGORIES: "GET_CATEGORIES",
   UPDATE_CATEGORY: "UPDATE_CATEGORY",
   DELETE_CATEGORY: "DELETE_CATEGORY",
   ERR_CATEGORY: "ERR_CATEGORY",
   CAT_LOADING: "CAT_LOADING", 
};


// actionTypes.js
export const media_actions = {
  UPLOAD_MEDIA_REQUEST: "UPLOAD_MEDIA_REQUEST",
  UPLOAD_MEDIA_SUCCESS: "UPLOAD_MEDIA_SUCCESS",
  UPLOAD_MEDIA_FAILURE: "UPLOAD_MEDIA_FAILURE",

  UPDATE_MEDIA_REQUEST: "UPDATE_MEDIA_REQUEST",
  UPDATE_MEDIA_SUCCESS: "UPDATE_MEDIA_SUCCESS",
  UPDATE_MEDIA_FAILURE: "UPDATE_MEDIA_FAILURE",
};
